import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class GridCard extends PureComponent {
    render() {
        var props = {
            ...this.props,
            className: `${ style.gridCard } ${ this.props.className }`.trim(),
            children: undefined,
        };

        return (
            <div { ...props }>
                { this.props.children }
            </div>
        );
    }
}
GridCard.defaultProps = {
    className: '',
    children: null,
};
